import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const conciergeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "AI agents", breadcrumbNavigate: false },
    children: [
      {
        path: "conversations",
        handle: { breadcrumb: "Conversations" },
        async lazy() {
          const [
            { ConciergeConversationsPage },
            { ConciergeConversationsV2RedirectGuard },
          ] = await Promise.all([
            import("./conversations/concierge-conversations-page"),
            import("./conversations/concierge-conversations-v2-redirect-guard"),
          ]);
          return {
            element: (
              <ConciergeConversationsV2RedirectGuard>
                <ConciergeConversationsPage />
              </ConciergeConversationsV2RedirectGuard>
            ),
          };
        },
      },
      {
        path: "monitoring",
        handle: { breadcrumb: "Monitoring" },
        async lazy() {
          const [
            { aiAgentMonitoringPage: AiAgentMonitoringPage },
            { ConciergeConversationsV2RedirectGuard },
          ] = await Promise.all([
            import("./monitoring/ai-agent-monitoring-page"),
            import("./conversations/concierge-conversations-v2-redirect-guard"),
          ]);
          return {
            element: (
              <ConciergeConversationsV2RedirectGuard>
                <AiAgentMonitoringPage />
              </ConciergeConversationsV2RedirectGuard>
            ),
          };
        },
      },
      {
        path: "testing",
        handle: { breadcrumb: "Testing" },
        async lazy() {
          const { AiAgentTestingPage } =
            await import("./testing/ai-agent-testing-page");
          return { Component: AiAgentTestingPage };
        },
      },
      {
        path: "knowledge",
        handle: { breadcrumb: "Knowledge" },
        async lazy() {
          const { ConciergeKnowledgePage } =
            await import("../setting/ai-agent/knowledge/page");
          return { Component: ConciergeKnowledgePage };
        },
      },
      {
        path: "about",
        async lazy() {
          const { AboutConcierge } = await import("./about");
          return { Component: AboutConcierge };
        },
      },
      {
        path: "onboard",
        async lazy() {
          const { SelfServePage } =
            await import("./self-serve/self-serve-page");
          return { Component: SelfServePage };
        },
      },
      {
        path: "preview",
        async lazy() {
          const { PreviewPage } = await import("./preview/preview-page");
          return { Component: PreviewPage };
        },
      },
    ],
  },
];
